import React from 'react';

import type { DemoCompaniesId, DemoCompanyEntityType } from 'src/constants/demoDashboardMode';
import {
  getDemoCompaniesIdServerSnapshot,
  getDemoCompaniesIdSnapshot,
  readDemoCompaniesId,
  setDemoCompanyEnabled,
  subscribeDemoCompaniesId,
  writeDemoCompaniesId,
} from 'src/utils/demoDashboardMode';

export const useDemoCompaniesId = () => {
  const demoCompaniesId = React.useSyncExternalStore(
    subscribeDemoCompaniesId,
    getDemoCompaniesIdSnapshot,
    getDemoCompaniesIdServerSnapshot,
  );

  const setDemoCompanyIdEnabled = React.useCallback(
    (entityType: DemoCompanyEntityType, entityId: string, enabled: boolean) => {
      const nextIds = setDemoCompanyEnabled(readDemoCompaniesId(), entityType, entityId, enabled);
      writeDemoCompaniesId(nextIds);
    },
    [],
  );

  return React.useMemo(
    () => ({
      demoCompaniesId,
      setDemoCompanyIdEnabled,
    }),
    [demoCompaniesId, setDemoCompanyIdEnabled],
  );
};

export type { DemoCompaniesId, DemoCompanyEntityType };
